import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { environment } from '../../../../environments/environment';
import { DatePipe } from '@angular/common';
import { Http } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { NavService } from '../../../../app/_services/NavService.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { TranslateConfigService } from '../../../../app/theme/home/translateConfig.service';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';
import { Helpers } from "../../../../app/helpers";
import { Observable } from 'rxjs';
import { ShipnowPopupComponent } from '../shipnow-popup/shipnow-popup.component';
declare var google: any;

interface PackageDetail {
  OrdersbyProductId: any
  PDescription: any;
  HSNNo: any;
  Qty: number;
  UnitRate: number;
  InvoiceAmount: number;
}

interface Package {
  PackageId: any
  NofPackages: string;
  Length: string;
  width: string;
  height: string;
  GrossWeight: string;
  packagedetail: PackageDetail[];
}

@Component({
  selector: 'app-contracted',
  templateUrl: './contracted.component.html',
  styleUrls: ['./contracted.component.scss']
})
export class ContractedComponent implements OnInit {

  TotalCount: any;
  start: any;
  length: number = 15;
  static that: ContractedComponent;
  Id: any = {};
  courierListIds: any = [];
  CourierList: any = [];
  CourierPackages: any = [];
  CourierDimentions: any = [];
  CourierAdditionalPack: any = [];
  TransportNames: any = [];
  OrderData: any = {};
  CompanyId: any;
  CourierRate: any = [];
  NetTotal: any = 0;
  TaxApplicableFlag: boolean = false;
  TenantId: any;
  UserId: any;
  tableDetails: ITableModel;
  pageTitle = "Contracted";
  isMobileView: boolean;
  searchValue: string = "";
  totalOrderCount: number = 0;
  filterObj: any = {
    Status: "All",
  };
  isListApiCalled: boolean;
  noOfPages: number = 10;
  TransationType: any;
  @ViewChild("ShipNowModal") ShipNowModal: TemplateRef<any>;
  modalRef: any;
  bookingData: any = {};
  TransportServiceList: any = [];
  ValidateTHCADvanceAmountFlag: boolean = false;
  ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag = false;
  isSTPBooking: any = false;
  ManualvehicleOrderDetail = [];
  ManualvehicleOrderList: any = [];
  ManualvehiclePlanning: any = {};
  STPModelListData: any = [];
  PANNo: any;
  ADCodeNo: any;
  IECNo: any;
  GSTNo: any;
  StateCode: any;
  StateName: any;
  data: any = {};
  Customer: any
  OrderId: any
  PrintDataShipment: any = {};
  PrintPackageData: any = {};
  // Added by Thanu --- 31-08-2024
  NewShipResults: any;
  returnData: any;
  jsonTest: any;
  APIUrl: any = environment.apiUrl;
  packages: Package[] = [];
  selectedStampPath: any;
  selectedLogoPath: any;
  // End

  Balance: any;
  IsAssignvehicleSaveDisable: any = false;
  netwktypeId: any;
  cardItems = [];
  modalTitle = "";
  modalMessage = "Are you sure you want to confirm this Shipment?";
  VehicleTypes: any = [];
  OrdersPackage: any = [];
  RateBifurcationList: any = [];
  @Output() transporterSelected: EventEmitter<any> = new EventEmitter<any>();
  selectedTransporterData: any[] = [];
  private refreshInterval: any;
  headerCategories = [
    {
      label: 'Send Rate Confirmation',
      subOptions: [
        { icon: 'assets/svg/General/Mail.svg', label: 'Via Mail', value: 'Via Mail' },
        { icon: 'assets/svg/General/SMS.svg', label: 'Via SMS', value: 'Via SMS' },
        { icon: 'assets/svg/General/Whatsapp.svg', label: 'Via WhatsApp', value: 'Via WhatsApp' },
        { icon: 'assets/svg/General/ViaAll.svg', label: 'Via All', value: 'Via All' }
      ]
    },
    {
      label: 'Send Vehicle Request',
      subOptions: [
        { icon: 'assets/svg/General/Mail.svg', label: 'Via Mail', value: 'Via Mail' },
        { icon: 'assets/svg/General/SMS.svg', label: 'Via SMS', value: 'Via SMS' },
        { icon: 'assets/svg/General/Whatsapp.svg', label: 'Via WhatsApp', value: 'Via WhatsApp' },
        { icon: 'assets/svg/General/ViaAll.svg', label: 'Via All', value: 'Via All' }
      ]
    },
    {
      label: 'Award Shipment',  //added by fahim 02-02-2026 :)
    }
  ];

  //added by fahim 2-1-2026 :)
  @ViewChild("ContractedRateBreak") ContractedRateBreak: TemplateRef<any>;
  ContracTransporterId:any;
  ContracIndentId:any;
  SelectedVehicleTypeId:any;
  SaveShipNowChargeBreakup:any=[];
  //End added by fahim 2-1-2026 :)
  @Input() TransportService: any; // Added by priya - 07/04/2026 - cn(PRIYA-APR26-002)
  
  @Input() IndentId: any; // Added by fahim 27-05-2026

  constructor(
    private route: ActivatedRoute,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private anghttp: Http,
    private commonService: CommonService,
    private decryptpipe: DecryptPipe,
    private service: TranslateConfigService,
    private modalService: NgbModal,
    private orderService: OrdersService,
    private router: Router,
    private dp: DatePipe,
    private _navService: NavService,
    private mobileDetectionService: MobileDetectionService,
  ) {
    ContractedComponent.that = this;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  companyDetails: any = {
    cardName: "Contracted",
    id: "Order",
    listOfRow: [
      [{
        dataField: 'CompanyName', imgDataField: 'Logo',
        divType: 'isUserDetails'
      }, { isRating: true, dataFieldRating: 'Rating' }],
      [
        {
          label: 'Expected PickUp', dataField: "PickupDate",
        },
        {
          label: 'Expected Delivery', dataField: "DeliveryDate",
        },
        {
          label: 'Charges', dataField: "Rate",
        },
      ],
      [
        {
          label: 'Vehicle Type', dataField: "FtlVehicleType", dataField1: "VehicleWeight",
        },
        {
          label: 'Weight/Volume', dataField: "TotalWeight", dataField1: "Volume",
        }
      ],
      [
        {
          label: 'Charges', dataField: "Rate",
        },
        {
          label: 'Is Mail', dataField: "IsMail",
        },
        {
          label: 'Mail Status', dataField: "MailStatus",
        },
      ]
    ],
    footer: {
      actionBtn: true,
      // isActiveDatafield: "IsActive",
      IsShipNowcard: true,
      color: "#3367FB",
      actionList: [
        {label: "Via Mail",command: (event?: any) => console.log(event),},
        {label: "Via SMS",command: (event?: any) => console.log(event),},
        {label: "Via WhatsApp" },
        {label: "Via All",},
      ],
    },
  };

  ARDetails: any = {
    cardName: "Contracted",
    id: "Order",
    listOfRow: [
      [{
        dataField: 'CompanyName', imgDataField: 'Imagepath',
        divType: 'isUserDetails'
      }, { isRating: true, dataFieldRating: 'Rating' }],
      [
        {
          label: 'Expected PickUp', dataField: "VehicleType",
        },
        {
          label: 'Expected Delivery', dataField: "DeliveryDate",
        },
        {
          label: 'Charges', dataField: "Rate",
        },
      ],
      [
        {
          label: 'Vehicle Type', dataField: "VehicleType", dataField1: "VehicleWeight",
        }
      ]
    ],
    footer: {
      actionBtn: false,
      // isActiveDatafield: "IsActive",
      isAgeDatafield: "TotalDaysInStage",
      color: "#3367FB",
      actionList: []
    },
  };

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    console.log('tenantId', this.TenantId)
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag =
      JSON.parse(
        localStorage.getItem(
          "ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag"
        )
      );
    const networkTypeIds = this.commonService.GetNetworkTypeIdsFromLocalStorage();
    this.netwktypeId = networkTypeIds[0];
    this.LoadTaxApplicable();
    this.GetTransportService();
    this.LoadValidateTHCADvanceAmount();
    this.LoadVehicleType();
    this.packages = [
      {
        PackageId: '',
        NofPackages: '',
        Length: '',
        width: '',
        height: '',
        GrossWeight: '',
        packagedetail: [
          {
            OrdersbyProductId: '',
            PDescription: '',
            HSNNo: '',
            Qty: 0,
            UnitRate: 0,
            InvoiceAmount: 0
          }
        ]
      }
    ];
    this.route.queryParamMap.subscribe((params) => {
      this.Id = params.get("id");
      this.TransationType = params.get("type");
      if (this.TransationType == "Country") {
        this.checkPaymentStatus();
        this.getWalletCount();
      }
      if (this.Id != null && this.Id != undefined && this.Id != "") {
        this.ShipList();
        if (this.TransationType == 'FTL' || this.TransationType == 'ContainerMovement') {
          this.initiateCourierList(this.Id);
        }
        if (this.TransationType == 'Country') {
          this.GetCourierRates();
        }
        if (this.TransationType == 'Air') {
          this.initiateCourierList(this.Id);
        }
      }
    });
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    this.refreshInterval = setInterval(() => {
    if(this.TransationType == 'ContainerMovement'){
      this.GetTransporterListForContainerMovement();
    }else{
      this.GetTransporterList();
    }
    }, 60000);
  }

  ngAfterViewInit() {
    this.getWalletCount();
  }

  ngOnDestroy() {
  if (this.refreshInterval) {
    clearInterval(this.refreshInterval);
  }
}

  intializeform() {
    this.Customer = {
      lable: 'Customer',
      formControlName: 'Customer',
      dataField: 'Customer',
      isRequired: true,
      type: "email",
      placeholder: 'Select Here',
      isSearchByApi: true,
      typeOfField: 'dropdown',
      isValueBind: true
    };
  }

  selectedRow(event) {
    if (!Array.isArray(this.selectedTransporterData)) {
      this.selectedTransporterData = [];
    }
    if (event.row.isSelected) {
      // const exists = this.selectedTransporterData.some(
      //   (item) => item.Id === event.row.Id
      // );
      // if (!exists) {
        this.selectedTransporterData.push({
          ...event.row,
          TransporterId: event.row.TransporterId,
          Transporter: event.row.CompanyName,
          IndentId: this.Id,
          IndentNo: this.CourierList[0].OrderNo,
          UserId: this.UserId,
        });
      // }
    } else {
      this.selectedTransporterData = this.selectedTransporterData.filter(
        (item) => item.Id !== event.row.Id
      );
    }
    this.transporterSelected.emit(this.selectedTransporterData);
    console.log('selectedTransporterData',this.selectedTransporterData);
  }

  GetCourierRates(start = this.start, length = this.length) {
    this._appService.Post("OrdersByVehicle", "GetCourerRates", { start, length, OrderId: this.Id }).subscribe((response) => {
      console.log(response, "GetCourerRates");
      if (response.length) {
        this.TotalCount = response[0].TotalCount;
        this.tableDetails.paginationDetails = {
          totalItems: this.TotalCount,
          itemsPerPage: length,
          currentPage: start + 1,
        };
      }
      this.tableDetails.data = response;
    });
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then((res) => {
      this.TransportServiceList = res;
    })
      .catch((error) => {
        console.log(error);
      });
  }

  LoadVehicleType() {
    this.orderService.GetVehicleTypeselect2("%%", 1).then((res) => {
      this.VehicleTypes = res;
    })
      .catch((error) => { });
  }

  checkPaymentStatus() {
    const orderId = localStorage.getItem('currentOrderId');
    if (orderId) {
      this._appService.GetByFourId('OrdersByVehicle', 'GetPaymentStatus_cashfree', orderId, this.CompanyId, this.netwktypeId, this.UserId).subscribe(
        (response) => {
          localStorage.removeItem('currentOrderId');
          this.getWalletCount();
        },
        (err) => {
          console.error('Error checking payment status:', err);
        }
      );
    }
    Helpers.setLoading(false);
  }

  LoadValidateTHCADvanceAmount() {
    this._appService.GetById("Common", "GetSystemSettingByName", "ValidateTHCADvanceAmount").subscribe(
      (response) => {
        if (response == "1") {
          this.ValidateTHCADvanceAmountFlag = true;
        } else {
          this.ValidateTHCADvanceAmountFlag = false;
        }
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      });
  }

  async ShipList() {
    if (this.TransationType == "FTL") {
      this.tableDetails = {
        data: [],
        columnDetails: [
          {
            columnName: "Service Providers",
            dataFieldName: "CompanyName",
            dataFieldName2: "TransporterPhone",
            dataFieldName3: "TransporterEmail",
            userIcon: "Logo",
            divType: "UserDetails",
            isContracted: true,
            isCheckBox: true,
          },
          {
            columnName: "Rating",
            dataFieldName: "Rating",
            divType: "newnetworkrating",
          },
          // {
          //   columnName: "Expected PickUp",
          //   dataFieldName: "OrderPickupDate",
          //   dataFieldName2: "FromPincode",
          //   dataFieldName3: "FromZone",
          //   divType: "ftlCustomers",
          // },
          // {
          //   columnName: "Expected Delivery", dataFieldName: "OrderDeliveryDate",
          //   dataFieldName2: "ToPincode",
          //   divType: "ftlCustomers",
          // },
          // { columnName: 'Available Services', dataFieldName: 'TransportCategory', dataFieldName2: 'TrnasporterWeightCriteria', dataFieldName3: 'CourierAdditionalPack', divType: 'courierService', },
          {
            columnName: "Weight/Volume",
            dataFieldName: "TotalWeight",
            dataFieldName2: "TotalVolume",
            divType: "ftlCustomers",
          },
          {
            columnName: "Vehicle Type",
            dataFieldName: "FtlVehicleType",
            //dataFieldName2: "VehicleWeight",
            divType: "ftlCustomers",
          },
          {
            columnName: "Charges",
            dataFieldName: "Rate",
            alignType: "right",
            width: "5%",
            divType: "ContractedRateBreakup",
          },
          {
            columnName: "Is Mail",
            dataFieldName: "IsMail",
          },
          {
            columnName: "Request Status",
            dataFieldName: "MailStatus",
          },
          {
            columnName: "Action",
            dataFieldName: "action",
            // dataFieldName2: "APICount",
            // dataFieldName3: "Rate",
            // dataFieldName4: "CompanyName",
            // dataFieldName5: "ShortName",
            // dataFieldName6: "Id",
            // dataFieldName7: "LeadTime",
            // dataFieldName8: "VehicleTypeId",
            dataFieldName10: "isBooking",
            divType: "NewContractAction",
            color: "#FFF",
            background: "#3b67fb",
          },
        ],
        actionList: [
          {label: "Via Mail",command: (event?: any) => console.log(event),},
          {label: "Via SMS",command: (event?: any) => console.log(event),},
          {label: "Via WhatsApp" },
          {label: "Via All",},
          {label: "Send Vehicle Request",},
        ],
        isColumnNameShow: true,
      };
    } else if (this.TransationType == "ContainerMovement") {
      this.tableDetails = {
        data: [],
        columnDetails: [
          {
            columnName: "Service Providers",
            dataFieldName: "CompanyName",
            dataFieldName2: "TransporterPhone",
            dataFieldName3: "TransporterEmail",
            userIcon: "Logo",
            divType: "UserDetails",
            isContracted: true,
            isCheckBox: true,
          },
          {
            columnName: "Rating",
            dataFieldName: "Rating",
            divType: "newnetworkrating",
          },
          // {
          //   columnName: "Expected PickUp",
          //   dataFieldName: "OrderPickupDate",
          //   dataFieldName2: "FromPincode",
          //   dataFieldName3: "FromZone",
          //   divType: "ftlCustomers",
          // },
          // {
          //   columnName: "Expected Delivery", dataFieldName: "OrderDeliveryDate",
          //   dataFieldName2: "ToPincode",
          //   divType: "ftlCustomers",
          // },
          // { columnName: 'Available Services', dataFieldName: 'TransportCategory', dataFieldName2: 'TrnasporterWeightCriteria', dataFieldName3: 'CourierAdditionalPack', divType: 'courierService', },
          {
            columnName: "Weight/Volume",
            dataFieldName: "TotalWeight",
            dataFieldName2: "Volume",
            divType: "ftlCustomers",
          },
          {
            columnName: "Vehicle Type",
            dataFieldName: "FtlVehicleType",
            //dataFieldName2: "VehicleWeight",
            divType: "ftlCustomers",
          },
          {
            columnName: "Charges",
            dataFieldName: "Rate",
            alignType: "right",
            width: "5%",
          },
          {
            columnName: "Is Mail",
            dataFieldName: "IsMail",
          },
          {
            columnName: "Request Status",
            dataFieldName: "MailStatus",
          },
          {
            columnName: "Action",
            dataFieldName: "action",
            // dataFieldName2: "APICount",
            // dataFieldName3: "Rate",
            // dataFieldName4: "CompanyName",
            // dataFieldName5: "ShortName",
            // dataFieldName6: "Id",
            // dataFieldName7: "LeadTime",
            // dataFieldName8: "VehicleTypeId",
            // dataFieldName9: "Type",
            dataFieldName10: "isBooking",
            divType: "NewContractAction",
            color: "#FFF",
            background: "#3b67fb",
          },
        ],
        actionList: [
          {label: "Via Mail",command: (event?: any) => console.log(event),},
          {label: "Via SMS",command: (event?: any) => console.log(event),},
          {label: "Via WhatsApp" },
          {label: "Via All",},
          {label: "Send Vehicle Request",},
        ],
        isColumnNameShow: true,
      };
    } else {
      this.tableDetails = {
        emptyDataMSg: "No Record Found",
        data: [],
        columnDetails: [
          {
            columnName: "Service Providers",
            dataFieldName: "CompanyName",
            dataFieldName2: "Rating",
            userIcon: "Imagepath",
            divType: "UserRatingDetails",
            isCompany: true,
            width: '20%'
          },
          { columnName: "Service Type", dataFieldName: "Description", dataFieldName2: 'ServiceType', divType: "ServiceType", width: '45%' },
          // {
          //   columnName: "Rating",
          //   dataFieldName: "Rating",
          //   divType: "newnetworkrating",
          // },
          { columnName: "Expected PickUp", dataFieldName: "PickupDate", width: '10%' },
          { columnName: "Expected Delivery", dataFieldName: "DeliveryDate", dataFieldName2: "LeadDays", width: '10%' },
          { columnName: "Total Amount", dataFieldName: "Rate", dataFieldName2: 'isBifurcationVisible', divType: "CurrencyAir", width: '15%', alignType: 'right' },
          {
            columnName: "Action",
            dataFieldName: "action",
            dataFieldName2: "APICount",
            dataFieldName3: "Rate",
            dataFieldName4: "CompanyName",
            dataFieldName5: "ShortName",
            dataFieldName6: "Id",
            dataFieldName7: "LeadTime",
            dataFieldName8: "VehicleTypeId",
            dataFieldName9: "Type",
            dataFieldName10: "ServiceType",
            divType: "NewShipAction",
            color: "#FFF",
            background: "#3b67fb",
          },
        ],
        actionList: [
          { label: "Via WhatsApp" },
          {
            label: "Via SMS",
            command: (event?: any) => console.log(event),
          },
          {
            label: "Via Mail",
            command: (event?: any) => console.log(event),
          },
          {
            label: "Set Minimum Bid Amount",
          },
        ],
        isColumnNameShow: true,
      };
    }
  }

  SendVehicleRequest(event, RequestType) {
    console.log('mail event', event)
    const eventArray = Array.isArray(event) ? event : [event];
    if (eventArray.length === 0) {
      this.toastr.warning("Please Select Transporter", "Error");
      return;
    }

    Helpers.setLoading(true);
    const transporterList = eventArray.map(function (element) {
      return {
        Address: (this.CourierList && this.CourierList[0] && this.CourierList[0].DeliveryAddress) ? this.CourierList[0].DeliveryAddress : '',
        BidAmount: 0,
        Email: (element && element.TransporterEmail) ? element.TransporterEmail : '',
        Id: (element && element.Id) ? element.Id : '',
        IndentId: this.Id,
        IndentNo: (this.CourierList && this.CourierList[0] && this.CourierList[0].OrderNo) ? this.CourierList[0].OrderNo : '',
        IsEmailSms: RequestType,
        MinBidAmount: 0,
        Name: (element && element.CompanyName) ? element.CompanyName : '',
        Phone: (element && element.TransporterPhone) ? element.TransporterPhone : '',
        Rating: (element && typeof element.Rating !== 'undefined') ? element.Rating : null,
        Transporter: (element && element.CompanyName) ? element.CompanyName : '',
        TransporterId: (element && element.Id) ? element.Id : '',
        TransporterType: "FTL",
        UserId: this.UserId,
        IsContracted: true,
        VehicleType: (element && element.NewVehicleType) ? element.NewVehicleType : '',
        VehicleTypeId: (element && element.VehicleTypeId) ? element.VehicleTypeId : '',
        TransporterBidDetailId: (element && element.TransporterBidDetailId) ? element.TransporterBidDetailId : '',
      };
    }.bind(this));
    console.log("transporterList:", transporterList);
    let pendingCount = 0;
    this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.Id).subscribe((res) => {
      pendingCount = res.Table[0].Pending;
      if (pendingCount <= 0) {
        this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
        return
      } else {
        this._appService.Post("OrdersByVehicle", "SendShipNowMail", transporterList)
        .subscribe(
          (response) => {
            Helpers.setLoading(false);
            if (response) {
              this.toastr.success("Request Sent Successfully !", "Success");
              this.selectedTransporterData = [];
            } else {
              this.toastr.error("Request sent failed !", "Error");
            }
          },
          (err) => {
            console.log(err);
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
      }
    });
  }

  SendRateConfirmation(event, RequestType) {
    console.log('mail event', event)
    // if (event.length == 0) {
    //   this.toastr.error("Please Select Transporter", "Error");
    //   return;
    // }
    if (!event || (Array.isArray(event) && event.length === 0)) {
        this.toastr.warning("Please Select Transporter", "Error");
        return;
    }
    Helpers.setLoading(true);

    const eventArray = Array.isArray(event) ? event : [event];

     const transporterList = eventArray.map(element => ({
        Address: this.CourierList[0].DeliveryAddress,
        BidAmount: 0,
        Email: element.TransporterEmail,
        Id: element.Id,
        IndentId: this.Id,
        IndentNo: this.CourierList[0].OrderNo,
        IsEmailSms: RequestType,
        MinBidAmount: 0,
        Name: element.CompanyName,
        Phone: element.TransporterPhone,
        Rating: element.Rating,
        Transporter: element.CompanyName,
        TransporterId: element.Id,
        TransporterType: element.TransporterType,
        UserId: this.UserId,
        IsContracted: true,
        VehicleTypeId: element.VehicleTypeId,
        VehicleType: element.VehicleType
    }));

    console.log('inside contract transporterList',transporterList);
    
    this._appService.Post("OrdersByVehicle", "SendRateConfirmationForContracted", transporterList).subscribe((response) => {
      Helpers.setLoading(false);
      if (response[0].isDone) {
        this.toastr.success("Request Sent Successfully !", "Success");
        transporterList.forEach(t => {
          this.GetExpenseBifurcation(t.IndentId, t.TransporterId,t.VehicleTypeId);
        });
        // this.GetTransporterList();
        if(this.TransationType == 'ContainerMovement'){
          this.GetTransporterListForContainerMovement();
        }else{
          this.GetTransporterList();
        }
      } else {
        this.toastr.error("Request sent failed !", "Error");
      }
    },
      (err) => {
        console.log(err);
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  ShipActionBtn(event) {
    // added by priya - 02/09/2025
    // if required vehicles count are fulfilled for order and pending vehicle is 0 then it will show warning
    let pendingCount = 0;
    this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.Id).subscribe((res) => {
      // pendingCount = res.Table[0].Pending;
      if (res && res.Table && res.Table.length > 0 && res.Table[0]) {
        pendingCount = res.Table[0].Pending ? res.Table[0].Pending : 0;
      }else{
        pendingCount=1;
      }
      if (pendingCount <= 0) {
        this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
        return
      } else {
        this.getWalletCount();
        var difference = 0;
        if (
          this.TransationType == "FTL" ||
          this.TransationType == "ContainerMovement"
        ) {
          this.cardItems = [
            { label: "Transporter", value: event.row.CompanyName },
            { label: "Amount", value: event.row.Rate.toFixed(2) },
          ];
        } else if (this.TransationType == "Air") {
          this.cardItems = [
            { label: "Transporter", value: event.row.CompanyName },
            { label: "Amount", value: event.row.Rate.toFixed(2) },
          ];
        } else {
          this.cardItems = [];
          const rateString = event.row.Rate.toString();
          const balanceString = this.Balance.toString();
          const rate = parseFloat(rateString.trim());
          const balance = parseFloat(balanceString.trim());

          difference = balance - rate;
          this.cardItems = [
            { label: "Transporter", value: event.row.CompanyName },
            {
              label: "Wallet Balance",
              value: ContractedComponent.that.Balance,
            },
            { label: "Amount", value: event.row.Rate.toFixed(2) },
            { label: "Difference", value: difference.toFixed(2) },
          ];
          if (difference < 0) {
            this.cardItems.push({
              label: "Warning",
              value: "Please Recharge First To Ship Now",
              color: "red",
            });
          }
        }
        const dialogRef = this.modalService.open(ShipnowPopupComponent, {
          centered: true,
        });
        dialogRef.componentInstance.details = {
          message: this.modalTitle,
          title: this.modalMessage,
        };
        dialogRef.componentInstance.cardItems = this.cardItems;
        if (this.TransationType != "FTL" && this.TransationType != 'Air') {
          if (difference < 0) {
            dialogRef.componentInstance.IsRateValid = false;
            dialogRef.componentInstance.IsRechargeBtnShow = true;
          } else {
            dialogRef.componentInstance.IsRateValid = true;
            dialogRef.componentInstance.IsRechargeBtnShow = false;
          }
        }
        if (this.TransationType == 'Air') {
          if (event.Rate > 0) {
            dialogRef.componentInstance.IsRateValid = true;
          }
        }
        if (this.TransationType == 'FTL') {
          dialogRef.componentInstance.IsRateValid = true;
        }

        dialogRef.componentInstance.close.subscribe((res: any) => {
          if (res) {
            if (this.TransationType == "FTL") {
              console.log('event', event, event.row)
              // Helpers.setLoading(true);
              // const transporterList = Array.isArray(event) ? event.map((element) => ({
              //   Address: this.CourierList[0].DeliveryAddress,
              //   BidAmount: 0,
              //   Email: element.row.TransporterEmail,
              //   Id: element.row.Id,
              //   IndentId: this.Id,
              //   IndentNo: this.CourierList[0].OrderNo,
              //   IsEmailSms: 'Mail',
              //   MinBidAmount: 0,
              //   Name: element.row.CompanyName,
              //   Phone: element.row.TransporterPhone,
              //   Rating: element.row.Rating,
              //   Transporter: element.row.CompanyName,
              //   TransporterId: element.row.Id,
              //   TransporterType: "FTL",
              //   UserId: this.UserId,
              //   IsContracted: true,
              //   VehicleTypeId: element.row.VehicleTypeId,
              // })) :
              //   [{
              //     Address: this.CourierList[0].DeliveryAddress,
              //     BidAmount: 0,
              //     Email: event.row.TransporterEmail,
              //     Id: event.row.Id,
              //     IndentId: this.Id,
              //     IndentNo: this.CourierList[0].OrderNo,
              //     IsEmailSms: 'Mail',
              //     MinBidAmount: 0,
              //     Name: event.row.CompanyName,
              //     Phone: event.row.TransporterPhone,
              //     Rating: event.row.Rating,
              //     Transporter: event.row.CompanyName,
              //     TransporterId: event.row.Id,
              //     TransporterType: "FTL",
              //     UserId: this.UserId,
              //     IsContracted: true,
              //     VehicleTypeId: event.row.VehicleTypeId,
              //   }];
              // console.log(transporterList)
              // this._appService.Post("OrdersByVehicle", "SendShipNowMail", transporterList).subscribe((response) => {
              //   Helpers.setLoading(false);
              //   if (response) {
              //     this.toastr.success("Request Sent Successfully !", "Success");
              //     // this.CreateBooking();
              //     this.bookingData.TransporterName = event.row.CompanyName;
              //     this.bookingData.Transporter = event.row.Id;
              //     this.bookingData.TransportService = this.TransportServiceList.filter(
              //     (x) => x.Label === "FTL"
              //     )[0].Id;
              //     this.bookingData.VehiclePlacementDate = this.dp.transform(
              //     new Date(),
              //     "dd-MMM-yyyy"
              //     );
              //     this.bookingData.EstimatedDeliveryDate = this.dp.transform(
              //     new Date(),
              //     "dd-MMM-yyyy"
              //     );
              //     this.bookingData.LeadTime = 0;
              //     this.bookingData.Advance = 0;
              //     this.bookingData.VehicleType = event.row.VehicleTypeId;
              //     this.modalRef = this.modalService.open(this.ShipNowModal);
              //   } else {
              //     this.toastr.error("Request sent failed !", "Error");
              //   }
              // },

              //   (err) => {
              //     console.log(err);
              //     Helpers.setLoading(false);
              //     this.toastr.error(err._body.replace(/"/g, ""), "Error");
              //   });

              this.bookingData.TransporterName = event.row.CompanyName;
              this.bookingData.Transporter = event.row.Id;
              // commented and added by priya - 07/04/2026 - cn(PRIYA-APR26-002)
              // this.bookingData.TransportService = this.TransportServiceList.filter(
              //   (x) => x.Label === "FTL"
              // )[0].Id;
              let selectedService = this.TransportServiceList.find(
                (x: any) => x.Label === this.TransportService.TransportName
              );
              if (!selectedService) {
                selectedService = this.TransportServiceList.find((x: any) => x.Label === "FTL");
              }
              this.bookingData.TransportService = selectedService ? selectedService.Id : null;
              // end by priya
              this.bookingData.VehiclePlacementDate = this.dp.transform(
              new Date(),
              "dd-MMM-yyyy HH:mm"
              );
              this.bookingData.EstimatedDeliveryDate = this.dp.transform(
              new Date(),
              "dd-MMM-yyyy HH:mm"
              );
              this.bookingData.LeadTime = 0;
              this.bookingData.Advance = 0;
              this.bookingData.VehicleType = event.row.VehicleTypeId;
              this.bookingData.ShortName = event && event.row ? event.row.ShortName : null;
              this.bookingData.TransporterType = event && event.row ? event.row.TransporterType : null;
              // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
              this.bookingData.VehicleDistance = event.row.VehicleDistance;
              this.bookingData.VehicleTravelTime = event.row.VehicleTravelTime;
              this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
              // End by priya
              this.modalRef = this.modalService.open(this.ShipNowModal, {windowClass: 'assign-vehicle-modal',centered: false});

              // this.bookingData.TransporterName = event.Transporter;
              // this.bookingData.Transporter = event.TransporterId;
              // this.bookingData.TransportService = this.TransportServiceList.filter(
              //   (x) => x.Label === "FTL"
              // )[0].Id;
              // this.bookingData.VehiclePlacementDate = this.dp.transform(
              //   new Date(),
              //   "dd-MMM-yyyy"
              // );
              // this.bookingData.EstimatedDeliveryDate = this.dp.transform(
              //   new Date(),
              //   "dd-MMM-yyyy"
              // );
              // this.bookingData.LeadTime = 0;
              // this.bookingData.Advance = 0;
              // this.bookingData.VehicleType = event.VehicleTypeId;
              // this.modalRef = this.modalService.open(this.ShipNowModal);
            } else if (this.TransationType == 'ContainerMovement') {
              // Added and commented by priya - 07/04/2026 - cn(PRIYA-APR26-002)
              this.bookingData.VehicleType = event.row.VehicleTypeId;
              this.bookingData.VehicleNo = event.row.RegistrationNo;
              this.bookingData.TransporterName = event.row.CompanyName;
              this.bookingData.Transporter = event.row.Id;
              this.bookingData.Driver = event.row.DriverName;
              this.bookingData.DriverName = event.row.Driver;
              this.bookingData.DriverCode = event.row.DriverCode;
              this.bookingData.DriverMobileNo = event.row.MobileNo;
              let selectedService = this.TransportServiceList.find(
                (x: any) => x.Label === this.TransportService.TransportName
              );
              this.bookingData.TransportService = selectedService ? selectedService.Id : null;
              this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
              this.bookingData.EstimatedDeliveryDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
              this.bookingData.LeadTime = 0;
              this.bookingData.Advance = 0;
              // end by priya
              // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
              this.bookingData.VehicleDistance = event.row.VehicleDistance;
              this.bookingData.VehicleTravelTime = event.row.VehicleTravelTime;
              this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
              // End by priya
            } else if (this.TransationType == 'Air') {
              this.OnClickShipNow(event.ShortName, event.TransporterId, event.Transporter, event.LeadTime, event.service_code, event.Rate);
            } else {
              if (difference < 0) {
                this.toastr.info("Please Recharge to Confirm Order", "Info");
              } else {
                dialogRef.componentInstance.IsRateValid = true;
                this.CreateConsignmentCountry(event.row.Id, event.row.LeadTime);
              }
              // this.CreateConsignment(null, null, event.row.Id, null, null, event.row.LeadTime);
              // this.OnClickShipNow(event.ShortName, event.TransporterId, event.Transporter, event.LeadTime);
            }
          }
          dialogRef.close();
        });
      }
    });
  }

  CreateBooking() {
    this._appService.GetBySixId("OrdersByVehicle", "CreareBookingFromOrder", this.Id, this.CompanyId, this.UserId, false, null, null).subscribe((response) => {
      Helpers.setLoading(false);
      if (response == 100) {
        this.toastr.error("Booking is already created !", "error");
      } else {
        this.toastr.success("Booking Created Successfully !", "Success");
        this.router.navigateByUrl(`/FtlList`);
      }
    },
      (err) => {
        console.log(err);
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  LoadTaxApplicable() {
    this._appService.GetById("Common", "GetSystemSettingByName", "IsTaxApplicable").subscribe(
      (response) => {
        if (response == "1") {
          this.TaxApplicableFlag = true;
        } else {
          this.TaxApplicableFlag = false;
        }
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      });
  }

  initiateCourierList(data: any) {
    this.courierListIds = data;
    var obj: any = {};
    obj.OrderId = this.courierListIds;

    this._appService.Post("OrdersByVehicle", "oc_GetCourierDataByIds", obj).subscribe(
      (response) => {
        this.CourierList = response.Table;
        this.CourierPackages = response.Table1;
        this.CourierDimentions = response.Table2;
        this.CourierAdditionalPack = response.Table4;
        this.OrdersPackage = response.Table5;

        var TransportName: any = [];
        this.CourierList.forEach((element) => {
          TransportName.push(element.TransportName);
        });
        this.TransportNames = Array.from(new Set(TransportName)).join(", ");

        this.OrderData.OrderCount = this.courierListIds.length;
        this.OrderData.SumOfQty = 0;
        this.OrderData.SumOfWeight = 0;
        this.OrderData.Volume = 0;
        this.OrderData.SumOFCFT = 0;

        this.CourierDimentions.forEach((element) => {
          this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.Qty;
        });
        this.CourierPackages.forEach((element) => {
          this.OrderData.SumOFCFT = this.OrderData.SumOFCFT + element.CFT;
          this.OrderData.SumOfWeight =
            this.OrderData.SumOfWeight + element.weight;
          this.OrderData.Volume = this.OrderData.Volume + element.Volume;
        });

        if (this.TransationType != 'Air') {
          this.GetCourierRate();
          // this.GetTransporterList();
          if(this.TransationType == 'ContainerMovement'){
            this.GetTransporterListForContainerMovement();
          }else{
            this.GetTransporterList();
          }
        } else {
          this.OrderData.SumOfQty = 0;
          this.OrderData.SumOfWeight = 0;
          this.OrderData.SumOfDimension = 0;
          this.OrdersPackage.forEach((element) => {
            this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.TotalPackages;
            this.OrderData.SumOfWeight = this.OrderData.SumOfWeight + element.GrossWeight;
            this.OrderData.SumOfDimension = this.OrderData.SumOfDimension + (element.Length + element.Width);
          });

          this.GetTransporterListAir();
        }

      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Courier data !",
          "error"
        );
      });
  }

  async GetCourierRate() {
    const hasComma = this.courierListIds.includes(",");

    var obj: any = [];
    if (hasComma == false) {
      obj.push(this.courierListIds);
    } else {
      obj = this.courierListIds.split(",").map((item) => item.trim());
    }

    for (let i = 0; i < obj.length; i++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService.GetByTwoId("OrdersByVehicle", "oc_GetCourierRate", obj[i], this.CompanyId).subscribe(
          (response) => {
            this.CourierRate = [];
            this.CourierRate = response;
            var SubTotal = 0;
            var totalSGST = 0;
            var totalCGST = 0;
            var totalIGST = 0;
            this.NetTotal = 0;
            this.CourierRate.forEach((element) => {
              SubTotal = SubTotal + element.ChargeRate;
              totalSGST =
                totalSGST + element.ChargeRate * (element.SGST / 100);
              totalCGST =
                totalCGST + element.ChargeRate * (element.CGST / 100);
              totalIGST =
                totalIGST + element.ChargeRate * (element.IGST / 100);
            });
            SubTotal = parseFloat(SubTotal.toFixed(2));
            totalSGST = parseFloat(totalSGST.toFixed(2));
            totalCGST = parseFloat(totalCGST.toFixed(2));
            totalIGST = parseFloat(totalIGST.toFixed(2));

            if (this.TaxApplicableFlag == false) {
              this.NetTotal = parseFloat(SubTotal.toFixed(2));
              totalSGST = 0;
              totalCGST = 0;
              totalIGST = 0;
            } else {
              this.NetTotal = parseFloat(
                (SubTotal + totalSGST + totalCGST + totalIGST).toFixed(2)
              );
            }
            resolve1("OK");
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching courier rate data !",
              "error"
            );
            resolve1("OK");
          });
      });
    }
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails,
      paginationDetails: {
        totalItems: this.totalOrderCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1,
      },
      data: data,
    };

    if (this.TransationType == 'Air') {
      this.mapTableDetails();
    } else {
      var veh_type = this.findNearestObject(this.OrderData.SumOfWeight);
      this.tableDetails.data.map((x) => {
        x.FirstLetter = x.CompanyName.substring(0, 1).toUpperCase();
        x.action = "Ship Now";
        x.PickupDate = this.CourierList[0].PickupDate;
        x.Rating = x.Rating;
        x.CourierAdditionalPack = this.CourierAdditionalPack;
        x.Volume = this.OrderData.Volume.toFixed(2);
        x.TotalWeight = this.OrderData.SumOfWeight.toFixed(2) + " Kg";
        if (this.TransationType == 'FTL') {
          // x.VehicleType = veh_type == null || veh_type == undefined ? null : veh_type.name;
          x.VehicleWeight = veh_type == null || veh_type == undefined ? null : veh_type.VehicleWeight.toFixed(2) + " Kg";
          // x.VehicleTypeId = veh_type == null || veh_type == undefined ? null : veh_type.id;
          x.Type = "FTL";
        }
        if (this.TransationType == 'Air') {
          x.VehicleTypeId = null;
          x.Type = "Air";
          x.LeadDays = x.LeadTime + ' Days';
        }
      });
    }
    this.PatchTransporterRates();
  }

  async mapTableDetails() {
    const promises = this.tableDetails.data.map(async (x) => {
      x.FirstLetter = x.CompanyName.substring(0, 1).toUpperCase();
      x.action = "Ship Now";
      x.PickupDate = this.CourierList[0].PickupDate;
      x.Rating = x.Rating;
      x.CourierAdditionalPack = this.CourierAdditionalPack;
      x.Volume = this.OrderData.Volume.toFixed(2);
      x.TotalWeight = this.OrderData.SumOfWeight + " Kg";
      x.VehicleTypeId = null;
      x.Type = "Air";
      x.LeadDays = x.LeadTime + ' Days';
      x.isBifurcationVisible = false;

      try {
        const response = await this._appService.GetByFourId(
          "OrdersByVehicle",
          "GetCalculateAirRateGST",
          this.Id,
          x.ChargeCode,
          x.Rate,
          x.ServiceType
        ).toPromise();

        console.log('API response:', response);

        const totalAmount = response.Table[0].TotalAmount;
        if (totalAmount) {
          x.Rate = totalAmount;
        } else {
          console.warn('TotalAmount is not available in response.');
        }
      } catch (err) {
        Helpers.setLoading(false);
        console.error('Error fetching rate:', err);
        this.toastr.error(
          this.translate.instant("User.ErrorMessage"),
          "error"
        );
      }
    });

    await Promise.all(promises);
    Helpers.setLoading(false);
  }

  isWithinRange(weight_util, min, max) {
    return weight_util >= min && weight_util <= max;
  }

  findNearestObject(packageWeight) {
    let nearestWeight = null;
    let minDifference = Infinity;

    if (this.VehicleTypes.length == 1) {
      nearestWeight = this.VehicleTypes[0];
    } else {
      this.VehicleTypes.forEach((object) => {
        const objectWeight = object.VehicleWeight;
        const difference = Math.abs(packageWeight - objectWeight);
        if (object.VehicleWeight > packageWeight) {
          if (difference < minDifference) {
            minDifference = difference;
            var weight_util = (
              (packageWeight / object.VehicleWeight) *
              100
            ).toFixed(2);
            if (this.isWithinRange(weight_util, 80, 100)) {
              nearestWeight = object;
            } else {
              nearestWeight = object;
            }
          }
        }
      });
    }
    // Return the nearest object weight
    return nearestWeight;
  }

  onPageChange(pageNo: number) {
    // this.GetTransporterList("", pageNo - 1);
    if(this.TransationType == 'ContainerMovement'){
      this.GetTransporterListForContainerMovement("", pageNo - 1);
    }else{
      this.GetTransporterList("", pageNo - 1);
    }
  }

  onPageNumberChange(noOfPages: any) {
    // this.GetTransporterList("", 0, {}, noOfPages);
    if(this.TransationType == 'ContainerMovement'){
      this.GetTransporterListForContainerMovement("", 0, {}, noOfPages);
    }else{
      this.GetTransporterList("", 0, {}, noOfPages);
    }
  }

  onFilterClickApply(event) {
    // this.GetTransporterList();
    if(this.TransationType == 'ContainerMovement'){
      this.GetTransporterListForContainerMovement();
    }else{
      this.GetTransporterList();
    }
  }

  onFilterClick() { }

  onFilterSearch(event) { }

  onActionClick({ row, actionName }) {
    if (actionName.trim() == "Via Mail") {
      this.SendRateConfirmation(row, "Mail");
    }
    if (actionName == "Generate Invoice") {
      if (row.status == 'Pending') {

      }
      this.obv_Print_Shipment();
    }
    if (actionName == "Authorization Print") {
      this.Print_Authorization();
    }
    if (actionName == "SLI Print") {
      this.Print_SLI();
    }
    if (actionName.trim() == 'Send Vehicle Request') {
       let transporterList = [];
        transporterList = Array.isArray(event) ? event.map((element) => ({
        Address: this.CourierList[0].DeliveryAddress,
        BidAmount: 0,
        Email: element.row.TransporterEmail,
        Id: element.row.Id,
        IndentId: this.Id,
        IndentNo: this.CourierList[0].OrderNo,
        IsEmailSms: 'Mail',
        MinBidAmount: 0,
        Name: element.row.CompanyName,
        Phone: element.row.TransporterPhone,
        Rating: element.row.Rating,
        Transporter: element.row.CompanyName,
        TransporterId: element.row.Id,
        TransporterType: "FTL",
        UserId: this.UserId,
        IsContracted: true,
        VehicleType: element.row.NewVehicleType,
        VehicleTypeId: element.row.VehicleTypeId,
        })) :
          [{
            Address: this.CourierList[0].DeliveryAddress,
            BidAmount: 0,
            Email: row.TransporterEmail,
            Id: row.Id,
            IndentId: this.Id,
            IndentNo: this.CourierList[0].OrderNo,
            IsEmailSms: 'Mail',
            MinBidAmount: 0,
            Name: row.CompanyName,
            Phone: row.TransporterPhone,
            Rating: row.Rating,
            Transporter: row.CompanyName,
            TransporterId: row.Id,
            TransporterType: "FTL",
            UserId: this.UserId,
            IsContracted: true,
            VehicleType: row.NewVehicleType,
            VehicleTypeId: row.VehicleTypeId,
            TransporterBidDetailId: row.TransporterBidDetailId
          }];
        console.log("transporterList:", transporterList);
      let pendingCount = 0;
      this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.Id).subscribe((res) => {
        pendingCount = res.Table[0].Pending;
        if (pendingCount <= 0) {
          this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
          return
        } else {
          this._appService.Post("OrdersByVehicle", "SendShipNowMail", transporterList).subscribe(
          (response) => {
              if (response) {
                  this.toastr.success("Request Sent Successfully !", "Success");
                } else {
                  this.toastr.error("Request sent failed !", "Error");
                }
            },
            (err) => {
              console.log(err);
              Helpers.setLoading(false);
              this.toastr.error(err._body.replace(/"/g, ""), "Error");
            }
          );
        }
      });
    }
    // if (actionName == "Duplicate") {

    // }
  }

  obv_Print_Shipment() {
    this._appService.GetById('OrdersByVehicle', 'obv_printshipment', this.OrderId).subscribe(
      (response) => {
        console.log(response)
        if (response && response.Table && response.Table[0] && response.Table[0].OrderData) {
          this.PrintDataShipment = JSON.parse(response.Table[0].OrderData);
        }
        if (response && response.Table1 && response.Table1[0] && response.Table1[0].PackageData) {
          this.PrintPackageData = JSON.parse(response.Table1[0].PackageData);
        }
        console.log(this.PrintDataShipment, 'PrintDatashipment');
        console.log(this.PrintPackageData, 'PrintPackageData');
      },
      (err) => {
        console.log(err);
      })
    setTimeout(() => {
      var divElements = document.getElementById("obv_Print");
      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      var printDiv = "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A3;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 1000);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      Helpers.setLoading(false);
    }, 300);
  }

  Print_Authorization() {
    console.log("Custoer Authorized Printo", this.data[this.Customer.dataField]);
    this.GetCustomerDocument(this.data[this.Customer.dataField]);
    setTimeout(() => {
      var divElements = document.getElementById("Authorization_Print");
      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      var printDiv = "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 1000);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      Helpers.setLoading(false);
    }, 300);
  }

  Print_SLI() {
    this.GetKYCData(this.data[this.Customer.dataField]);
    setTimeout(() => {
      var divElements = document.getElementById("SLI_Print");
      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      var printDiv = "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 1000);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      Helpers.setLoading(false);
    }, 300);
  }

  processOrderData() {
    Helpers.setLoading(true);
    const jsonResult = {
      packages: this.packages.map(pack => ({
        NofPackages: pack.NofPackages,
        Length: pack.Length,
        Width: pack.width,
        Height: pack.height,
        GrossWeight: pack.GrossWeight,
        details: pack.packagedetail.map(pkg => ({
          PDescription: pkg.PDescription,
          HSNNo: pkg.HSNNo,
          Qty: pkg.Qty,
          UnitRate: pkg.UnitRate,
          InvoiceAmount: pkg.InvoiceAmount
        }))
      }))
    };
    this.data.package = jsonResult;
    this.data.CompanyId = this.CompanyId
    this.data.TenantId = this.TenantId
    this.data.UserId = this.UserId
    this.data.OrderId = this.OrderId
  }

  GetCustomerDocument(id: string) {
    // if (this.CompanyIdforctp) {
    //   this.toastr.warning("Please select customer to print authorization letter", "Warning");
    //   return;
    // }  
    this._appService.GetByOneParam('OrdersByVehicle', 'GetCustomerDocument', this.data[this.Customer.dataField]).subscribe(
      (response: any) => {
        console.log("API Response:", response); // Log the full response
        // Check if response is an array and has at least one element
        const data = Array.isArray(response) && response.length > 0 ? response[0] : response;
        console.log("Data Object:", data);
        if (data && data.Table[0].StampPath && data.Table[0].LogoPath) {
          this.selectedStampPath = environment.apiUrl + encodeURI(data.Table[0].StampPath);
          this.selectedLogoPath = environment.apiUrl + encodeURI(data.Table[0].LogoPath);
          console.log("Stamp Path:", this.selectedStampPath);
          console.log("Logo Path:", this.selectedLogoPath);
        } else {
          console.error("Response does not contain expected properties or is not in expected format");
        }
      },
      (error: any) => {
        console.error("API request failed", error);
        this.toastr.error("Failed to fetch customer document", "Error");
      }
    );
  }

  GetKYCData(id: string) {
    this._appService.GetByOneParam('OrdersByVehicle', 'GetSLIdocumentData', this.data[this.Customer.dataField]).subscribe(
      (response: any) => {
        console.log("GetSLIdocumentData", response);
        // Assuming response.Table is an array of documents
        if (response && response.Table && Array.isArray(response.Table)) {
          response.Table.forEach((doc: any) => {
            switch (doc.Name) {
              case 'PAN':
                this.PANNo = doc.DocumentNo;
                break;
              case 'AD Code Letter':
                this.ADCodeNo = doc.DocumentNo;
                break;
              case 'Import Export Certificate (IEC) copy':
                this.IECNo = doc.DocumentNo;
                break;
              case 'GST certificate':
                this.GSTNo = doc.DocumentNo;
                this.StateCode = doc.StateCode;
                this.StateName = doc.StateName;
                break;
              default:
                console.warn(`Unrecognized document: ${doc.Name}`);
            }
          });
        }
      },
      (error: any) => {
        console.error("API request failed", error);
      }
    );
  }

  GetTransporterList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    isFilter = false
  ) {
    Helpers.setLoading(true);
    var TransportId = filterObject.Transporter || null
    let start = (pageNo * perPage)
    this._appService
      .GetByElevenId(
        "OrdersByVehicle",
        "GetTransportersFTL",
        this.CourierList[0].PickupPincode,
        this.CourierList[0].DeliveryPincode,
        this.CourierList[0].PickupCity,
        this.CourierList[0].DeliveryCity,
        this.CourierList[0].TransportService,
        this.CourierList[0].PickupDate,
        this.OrderData.SumOfWeight,
        TransportId,
        start,
        perPage,
        this.Id
      ).subscribe(
        (response) => {
          if (response.Table.length) {
            
            // response.Table.forEach(item => {
            // if (!item.Logo || item.Logo.trim() === "../../Document/Logos/.") {
            //     item.Logo = null;
            //   }
            // });
            
            console.log('contracted list', response);

            this.totalOrderCount = response.Table[0].Count; //response[0].recordcount;
            this.selectedTransporterData=[];
            this.isListApiCalled = true;
            this.assignTableFields(pageNo, perPage, response.Table);
            console.log('Inside ContractedComponent');
          }
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(
            this.translate.instant("User.ErrorMessage"),
            "error"
          );
        });
  }

  GetTransporterListForContainerMovement(searchValue = this.searchValue,pageNo: number = 0,filterObject: any = this.filterObj,perPage: any = this.noOfPages,isFilter = false) {
    Helpers.setLoading(true);
    var TransportId = filterObject.Transporter || null
    let start = (pageNo * perPage)
    var obj:any={};
    obj.fromPincode=this.CourierList[0].PickupPincode;
    obj.toPincode=this.CourierList[0].DeliveryPincode;
    obj.fromCity=this.CourierList[0].PickupCity;
    obj.toCity=this.CourierList[0].DeliveryCity;
    obj.pickupDate=this.CourierList[0].PickupDate;
    obj.transportService=this.CourierList[0].TransportService;
    obj.TotalWeight=this.OrderData.SumOfWeight;
    obj.TransporterId=TransportId;
    obj.pageNo=start;
    obj.perPage=perPage;
    obj.OrderId=this.Id;

    this._appService.Post("OrdersByVehicle","GetContractedTransportersContainerMovement",obj).subscribe(
        (response) => {
          if (response.length > 0) {
            console.log('contracted list For ContainerMovement', response);
            this.totalOrderCount = response[0].Count; 
            this.selectedTransporterData=[];
            this.isListApiCalled = true;
            this.assignTableFields(pageNo, perPage, response);
            console.log('Inside ContractedComponent');
          }
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(
            this.translate.instant("User.ErrorMessage"),
            "error"
          );
        });
  }

  async PatchTransporterRates() {
    const hasComma = this.courierListIds.includes(",");
    var obj: any;
    if (hasComma == false) {
      obj = this.courierListIds;
      this.courierListIds = [];
      this.courierListIds.push(obj);
    } else {
      this.courierListIds = this.courierListIds
        .split(",")
        .map((item) => item.trim());
    }

    for (let i = 0; i < this.courierListIds.length; i++) {
      for (let k = 0; k < this.tableDetails.data.length; k++) {
        Helpers.setLoading(true);
        await new Promise(async (resolve1, reject1) => {
          this._appService.GetByTwoId("OrdersByVehicle", "so_GetOrderRate_Transporter", this.courierListIds[i], this.tableDetails.data[k].Id).subscribe(
            async (res) => {
              var response = (await res) as any;
              var sum = 0;
              response.forEach((element) => {
                sum = sum + element.ChargeRate;
              });

              this.tableDetails.data[k].Rate =
                this.tableDetails.data[k].Rate + sum;
              resolve1("OK");
              Helpers.setLoading(false);

            if (response.length > 0) {
              setTimeout(() => {
                if (
                  this.courierListIds.length == i + 1 &&
                  this.tableDetails.data.length == k + 1
                ) {
                  this.tableDetails.data.sort((obj1, obj2) => {
                    if (
                      obj1.IsRecommended == "YES" &&
                      obj2.IsRecommended == "YES"
                    ) {
                      if (obj1.Rate > obj2.Rate) {
                        return 1;
                      } else {
                        return -1;
                      }
                    }
                    if (
                      obj1.IsRecommended != "YES" &&
                      obj2.IsRecommended != "YES"
                    ) {
                      if (obj1.Rate > obj2.Rate) {
                        return 1;
                      } else {
                        return -1;
                      }
                    }
                    return 0;
                  });
                }
              }, 300);
            }
            },
            (err) => {
              this.toastr.error(
                "Error occurred while fetching data !",
                "error"
              );
              resolve1("OK");
              Helpers.setLoading(false);
            });
        });
      }
    }

    for (let k = 0; k < this.tableDetails.data.length; k++) {
      if (this.tableDetails.data[k].Rate == 0) {
        if (this.TransationType == "FTL") {
          // this.tableDetails.data.splice(k, 1);
        }
      }
    }
  }

  async OnClickShipNow(ShortName, TransporterId, TransporterName, LeadTime, service_code, TotalRate) {
    // const hasComma = this.courierListIds.includes(",");
    // 
    // var obj: any;
    // if (hasComma == false) {
    //   obj = this.courierListIds;
    //   this.courierListIds = [];
    //   this.courierListIds.push(obj);
    // }
    for (let a = 0; a < this.courierListIds.length; a++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService.GetById("OrdersByVehicle", "oc_GetCourierDataByIdConsignment", ContractedComponent.that.courierListIds[a]).subscribe(
          (response) => {
            var obj: any = {};
            obj.OrderDetails = response.Table[0];
            obj.ProductDetails = response.Table1;
            obj.ProductDimentions = response.Table2;
            obj.InvoiceDetails = response.Table3;
            obj.AdditionalServices = response.Table4;
            obj.OrdersPackage = response.Table5;

            var ConsignmentList: any = [];
            ConsignmentList.push(obj);
            ContractedComponent.that.CreateConsignment(obj,ShortName,ContractedComponent.that.courierListIds[a],TransporterId,TransporterName,LeadTime,service_code,TotalRate);
            resolve1("OK");
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
            resolve1("OK");
          });
      });
    }
  }

  async CreateConsignment(
    a: any,
    TransporterShortName: any,
    OrderId: any,
    TransporterId: any,
    TransporterName: any,
    LeadTime: any,
    service_code: any,
    TotalRate: any
  ) {
    var data: any = {};

    data.consignment = {};
    data.consignment.consolidate = 'No'; //this.DiffLocations == true ? 'No' : 'Yes';
    data.consignment.shipper_company_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignment_number = '';
    data.consignment.is_draft = "No";
    data.consignment.from_challan_id = "";
    data.consignment.consignor_company_id = "";
    data.consignment.consignor_company_name = a.OrderDetails.ConsignorCompany;
    data.consignment.consignor_company_code = a.OrderDetails.ConsignorCode;
    data.consignment.consignor_facility_name = a.OrderDetails.PickupCity;
    data.consignment.consignor_facility_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignor_address_line1 = a.OrderDetails.ConsignerAddress;
    data.consignment.consignor_address_line2 = "";
    data.consignment.consignor_city = a.OrderDetails.ConsignerCity;
    data.consignment.consignor_state = a.OrderDetails.ConsignerState;
    data.consignment.consignor_pin = a.OrderDetails.ConsignerPincode;
    data.consignment.consignor_contact_name = a.OrderDetails.PickUpContactPerson;
    data.consignment.consignor_phone = a.OrderDetails.PickUpContactNumber;
    data.consignment.consignee_company_id = "";
    data.consignment.consignee_company_name = a.OrderDetails.ConsigneeName;
    data.consignment.consignee_company_code = a.OrderDetails.ConsigneeCode;
    data.consignment.consignee_facility_name = a.OrderDetails.DeliveryCity;
    data.consignment.consignee_facility_code = a.OrderDetails.DeliveryLocationCode;
    data.consignment.consignee_address_line1 = a.OrderDetails.ConsigneeAddress;
    data.consignment.consignee_address_line2 = "";
    data.consignment.consignee_city = a.OrderDetails.ConsigneeCity;
    data.consignment.consignee_state = a.OrderDetails.ConsigneeState;
    data.consignment.consignee_pin = a.OrderDetails.ConsigneePincode;
    data.consignment.consignee_contact_name = a.OrderDetails.DeliveryContactPerson;
    data.consignment.consignee_phone = a.OrderDetails.DeliveryContactNumber;
    data.consignment.reference_number_1 = a.OrderDetails.ReferenceNo;
    data.consignment.reference_number_2 = "";
    data.consignment.service_option = 'SURF XPRS'; //a.OrderDetails.TransportName;
    data.consignment.truck_category = "";
    data.consignment.service_provider_company_code = TransporterShortName;
    data.consignment.vehicle_number = "";
    data.consignment.driver_name = "";
    data.consignment.driver_mobile_number = "";
    data.consignment.volume = ""; //a.OrderDetails.Volume;
    data.consignment.volume_measure = "";
    data.consignment.ready_for_pickup_at = a.OrderDetails.PickupLocationCode;
    data.consignment.payment_mode = 'To Bill'; //a.OrderDetails.Freight;
    data.consignment.slot_date = "";
    data.consignment.slot_name = "";
    data.consignment.slot_company_code = "";
    data.consignment.weight = a.OrderDetails.Weight;
    data.consignment.billable_weight = a.OrderDetails.VolumetricWeight > a.OrderDetails.Weight == true ? a.OrderDetails.VolumetricWeight : a.OrderDetails.Weight;
    data.consignment.weight_measure = "Kgs";

    data.consignment.consignment_contents = {};
    data.consignment.consignment_contents.consignment_content = [];
    data.product_data = [];
    data.products = [];
    data.consignment_contents_common = {};
    data.consignment_contents_common.consignment_content_common = [];
    for (let k = 0; k < a.ProductDetails.length; k++) {
      var obj: any = {};

      obj.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj.delivery_number = null; //ASK
      obj.product_id = "";
      obj.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj.product_display_name = a.ProductDetails[k].ProductName;
      obj.units = a.ProductDetails[k].Qty;
      obj.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj.weight = a.ProductDetails[k].weight;
      obj.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.length = a.ProductDetails[k].Length;
      obj.width = a.ProductDetails[k].Width;
      obj.height = a.ProductDetails[k].Height;
      obj.uom = 'inches'; //a.ProductDetails[k].UnitName;
      data.consignment.consignment_contents.consignment_content.push(obj);

      //************************************************************** */
      var obj2: any = {};
      obj2.hsnno = a.ProductDetails[k].HSNNo;
      obj2.product_name = a.ProductDetails[k].ProductName;

      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj2.SGSTAmount = total * (9 / 100);
        obj2.CGSTAmount = total * (9 / 100);
        obj2.IGSTAmount = 0;
        obj2.GSTTaxRateCGSTN = 9;
        obj2.GSTTaxRateSGSTN = 9;
        obj2.GSTTAXRateIGSTN = 0;
      } else {
        obj2.SGSTAmount = 0;
        obj2.CGSTAmount = 0;
        obj2.IGSTAmount = total * (18 / 100);
        obj2.GSTTaxRateCGSTN = 0;
        obj2.GSTTaxRateSGSTN = 0;
        obj2.GSTTAXRateIGSTN = 18;
      }

      obj2.Discount = 0;
      obj2.GSTTaxTotal = (obj2.SGSTAmount + obj2.CGSTAmount + obj2.IGSTAmount);
      obj2.TaxableValue = total + obj2.GSTTaxTotal;
      data.product_data.push(obj2);

      //************************************************************** */
      var obj3: any = {};

      obj3.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj3.delivery_number = null; //ASK
      obj3.product_id = "";
      obj3.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj3.product_display_name = a.ProductDetails[k].ProductName;
      obj3.units = a.ProductDetails[k].Qty;
      obj3.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj3.weight = a.ProductDetails[k].ProductWeight;
      obj3.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj3.weight_measure = "Kgs";
      obj3.length = a.ProductDetails[k].Length;
      obj3.width = a.ProductDetails[k].Width;
      obj3.height = a.ProductDetails[k].Height;
      obj3.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj3.hsnno = a.ProductDetails[k].HSNNo;
      obj3.price = a.ProductDetails[k].Price;
      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj3.SGSTAmount = total * (9 / 100);
        obj3.CGSTAmount = total * (9 / 100);
        obj3.IGSTAmount = 0;
        obj3.GSTTaxRateCGSTN = 9;
        obj3.GSTTaxRateSGSTN = 9;
        obj3.GSTTAXRateIGSTN = 0;
      } else {
        obj3.SGSTAmount = 0;
        obj3.CGSTAmount = 0;
        obj3.IGSTAmount = total * (18 / 100);
        obj3.GSTTaxRateCGSTN = 0;
        obj3.GSTTaxRateSGSTN = 0;
        obj3.GSTTAXRateIGSTN = 18;
      }
      obj3.Discount = 0;
      obj3.GSTTaxTotal = (obj3.SGSTAmount + obj3.CGSTAmount + obj3.IGSTAmount);
      obj3.TaxableValue = total + obj3.GSTTaxTotal;
      data.products.push(obj3);

      var obj4: any = {};

      obj4.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj4.delivery_number = null; //ASK
      obj4.product_id = "";
      obj4.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj4.product_display_name = a.ProductDetails[k].ProductName;
      obj4.units = a.ProductDetails[k].Qty;
      obj4.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj4.weight = a.ProductDetails[k].weight;
      obj4.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj4.weight_measure = "Kgs";
      obj4.length = a.ProductDetails[k].Length;
      obj4.width = a.ProductDetails[k].Width;
      obj4.height = a.ProductDetails[k].Height;
      obj4.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj4.Barcode = a.ProductDetails[k].Barcode;
      obj4.product_code = a.ProductDetails[k].ProductCode;
      obj4.Category = a.ProductDetails[k].Category;
      data.consignment_contents_common.consignment_content_common.push(obj4);
    }

    data.consignment.consignment_invoices = {};
    data.consignment.consignment_invoices.consignment_invoice = [];
    for (let k = 0; k < a.InvoiceDetails.length; k++) {
      var obj: any = {};

      obj.invoice_number = a.InvoiceDetails[k].InvoiceNo;
      obj.delivery_number = null; //ASK
      obj.invoice_value = a.InvoiceDetails[k].Amount;
      obj.invoice_date = a.InvoiceDetails[k].InvoiceDate;
      obj.cod_amount = a.InvoiceDetails[k].Amount;
      obj.weight = a.OrderDetails.Weight;
      obj.billable_weight = a.InvoiceDetails[k].VolumetricWeight > a.OrderDetails.Weight ? a.InvoiceDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.pickable_units = a.InvoiceDetails[k].Qty;
      obj.eway_bill_number = a.InvoiceDetails[k].eWayBill;
      obj.eway_bill_expiry_date = a.InvoiceDetails[k].eWayBillExpiryDate;
      data.consignment.consignment_invoices.consignment_invoice.push(obj);
    }

    data.parcellist = [];
    for (let k = 0; k < a.OrdersPackage.length; k++) {
      var obj: any = {};
      obj.weight = a.OrdersPackage[k].GrossWeight;
      obj.length = a.OrdersPackage[k].Length;
      obj.height = a.OrdersPackage[k].Height;
      obj.width = a.OrdersPackage[k].Width;
      obj.item_description = a.OrdersPackage[k].ProductName;
      obj.no_of_items = a.OrdersPackage[k].TotalPackages;
      obj.item_value = a.OrdersPackage[k].InvoiceAmount;
      obj.hscode = a.OrdersPackage[k].HSNNo;
      data.parcellist.push(obj);
    }

    data.consignment.service_provider_id = "";
    data.consignment.service_provider_name = "";
    data.consignment.service_provider_code = "";
    data.consignment.consignment_type = "OUTBOUND-TBB";
    data.OrderId = OrderId;
    data.TransporterId = TransporterId;
    data.PickUpDateTime = a.OrderDetails.PickupDate;
    data.consignor_email = a.OrderDetails.PickUpContactEmail;
    data.consignee_email = a.OrderDetails.DeliveryContactEmail;
    data.consignor_lat = a.OrderDetails.PickUpLatitude;
    data.consignor_long = a.OrderDetails.PickUpLongtitude;
    data.consignee_lat = a.OrderDetails.DeliverLatitude;
    data.consignee_long = a.OrderDetails.DeliverLongtitude;
    data.tax_id = a.OrderDetails.PickupGSTNo;
    data.consignor_country = a.OrderDetails.PickupCountry;
    data.consignee_country = a.OrderDetails.DeliveryCountry;
    data.VolumetricWeight = a.OrderDetails.VolumetricWeight;
    data.PickupDateV2 = a.OrderDetails.PickupDateV2;

    data.Customer = {};
    data.Customer.CustomerAddress1 = a.OrderDetails.CustomerAddress;
    data.Customer.CustomerAddress2 = "";
    data.Customer.CustomerAddress3 = "";
    data.Customer.CustomerEmailID = a.OrderDetails.CustomerMail;
    data.Customer.CustomerGSTNumber = a.OrderDetails.CustomeGST;
    data.Customer.CustomerLatitude = "";
    data.Customer.CustomerLongitude = "";
    data.Customer.CustomerMobile = a.OrderDetails.CustomerMobile;
    data.Customer.CustomerName = a.OrderDetails.CustomerName;
    data.Customer.CustomerPincode = a.OrderDetails.CustomerPincode;
    data.service_code = service_code;

    console.log('CreateConsignment Method Data',data);
    Helpers.setLoading(true);
    await new Promise(async (resolve1, reject1) => {
      this._appService.Post("OrdersByVehicle", "CreateConsignment", data).subscribe(async (response) => {
            Helpers.setLoading(false);
            if (response.isScuccess == true) {
              this.toastr.success(this.translate.instant("ALERTMESSAGES.ConsignmentSuccess"),"Success");

              var ShipmentId, ShipmentNo = '';
              if (TransporterName == "Smart Track") {
                var msg = JSON.parse(response.message);
                ShipmentId = msg['data']['shipment_id'];
                ShipmentNo = msg['data']['shipment_number'];
              }

              Helpers.setLoading(true);
              this._appService.GetByEightId("OrdersByVehicle","oc_ConfirmCourierData_generateInvoiceOrderWiseV2",OrderId,this.UserId,TransporterId,LeadTime,ShipmentId,ShipmentNo,service_code,TotalRate).subscribe(async (response) => {
                    Helpers.setLoading(false);
                    if (response[0].isDone == "OK") {
                      this.toastr.success("Order Confirm successfully !","Success");

                      resolve1("Ok");
                      setTimeout(() => {
                        if (this.TransationType == "Air") {
                          this.getWalletCount();
                          window.location.href = '/NewBookingList';
                          // this.router.navigateByUrl(`/NewBookingList`);
                        } else {
                          this.router.navigateByUrl(`/FtlList`);
                        }
                      }, 1000);
                      Helpers.setLoading(false);
                    } else {
                      this.toastr.success("Error Occurred While ConFirm Booking !","Error");
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                    if (response[0].invoiceResult != "Success") {
                      this.toastr.success("Error Occurred While Generating Shipment !","Error");
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error(err._body.replace(/"/g, ""), "Error");
                    resolve1("Ok");
                  }
                );
            } else {
              var msg = JSON.parse(response.message);

              if (TransporterName == "V-Xpress")
                this.toastr.error(msg.exception.message, "Error");

              if (
                TransporterName == "Delhivery" ||
                TransporterName == "OM Logistics"
              )
                this.toastr.error(msg.message, "Error");

              if (TransporterName == "XpressBees")
                this.toastr.error(msg.ReturnMessage, "Error");

              if (TransporterName == "Allcargo GATI") {
                // this.toastr.error(msg['meta']['message'], 'Error');
                const detailsArray = msg["meta"]["details"][0];
                if (!detailsArray.includes("{")) {
                  this.toastr.error(detailsArray, "Error", {
                    enableHtml: true,
                  });
                } else {
                  const validJsonString = detailsArray.replace(/'/g, '"');
                  const detailsObject = JSON.parse(validJsonString);
                  let toastrMessage = "";

                  // Loop through details and format message
                  for (const key in detailsObject) {
                    if (detailsObject.hasOwnProperty(key)) {
                      const nestedObject = detailsObject[key];
                      for (const nestedKey in nestedObject) {
                        if (nestedObject.hasOwnProperty(nestedKey)) {
                          const errors = nestedObject[nestedKey];
                          if (Array.isArray(errors)) {
                            // If errors is an array, iterate over each error
                            errors.forEach((error: string) => {
                              toastrMessage += `${nestedKey}: ${error}<br>`;
                            });
                          } else if (typeof errors === "object") {
                            // If errors is an object, assume it has message arrays
                            for (const prop in errors) {
                              if (
                                errors.hasOwnProperty(prop) &&
                                Array.isArray(errors[prop])
                              ) {
                                errors[prop].forEach((error: string) => {
                                  toastrMessage += `${prop}: ${error}<br>`;
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  // Show toastr message
                  this.toastr.error(toastrMessage, "Error", {enableHtml: true,});
                }
              }

              if (TransporterName == 'Smartr Logistics') {
                this.toastr.error(msg.total_failure[0].error, 'Error');
              }

              if (TransporterName == 'TCI Express') {
                this.toastr.error(msg.error, 'Error');
              }

              if (TransporterName == 'Bluedart') {
                var dd = msg['error-response'];
                var ddList: any = [];
                dd.forEach(element => {
                  ddList.push(element.Status[0].StatusInformation);
                });
                const commaSeparatedString = ddList.join(', ');
                this.toastr.error(commaSeparatedString, 'Error');
              }

              if (TransporterName == 'DTDC') {
                var dd = msg['data'];
                var ddList: any = [];
                dd.forEach(element => {
                  ddList.push(element.message);
                });
                const commaSeparatedString = ddList.join(', ');
                this.toastr.error(commaSeparatedString, 'Error');
              }

              if (TransporterName == 'Safexpress') {
                const descriptions = msg.data.responseData.waybillApiResponse
                  .flatMap(item => item.response.map(r => r.description))
                  .join(', ');

                this.toastr.error(descriptions, 'Error');
              }

              Helpers.setLoading(false);
            }
            console.log(response);
          },
          (err) => {
            console.log(err);
            // this.toastr.error(err._body.replace(/"/g, ""), "Error");
            Helpers.setLoading(false);
          }
        );
    });
  }

  async calculateRouteOptimization(
    OrderInfoData,
    DestinationLocation
  ): Promise<Observable<any>> {
    try {
      if (DestinationLocation.length > 1) {
        const directionsService = new google.maps.DirectionsService();
        const waypts = [];
        for (let i = 0; i < DestinationLocation.length; i++) {
          waypts.push({
            location: DestinationLocation[i].location,
            stopover: true,
          });
        }
        await directionsService.route(
          {
            origin: OrderInfoData[0].origin,
            destination: OrderInfoData[0].destination,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              let ViewPoints = [];
              ViewPoints = response.routes[0].waypoint_order;
              var mainNum = 65;
              var subNum = 63;
              for (let i = 0; i < ViewPoints.length; i++) {
                DestinationLocation[ViewPoints[i]].Order = i;
                DestinationLocation[ViewPoints[i]].RouteOrder =
                  subNum == 63
                    ? String.fromCharCode(mainNum)
                    : String.fromCharCode(mainNum) +
                    String.fromCharCode(subNum);
                if (mainNum == 90 || subNum == 90) {
                  mainNum = subNum == 63 ? 65 : mainNum + 1;
                  subNum = 64;
                }
                subNum = subNum == 63 ? subNum : subNum + 1;
                mainNum = subNum == 63 ? mainNum + 1 : mainNum;
              }
              // this.OrderDestinationLocation1=(DestinationLocation);
              // return this.OrderDestinationLocation1;
            } else {
              // window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    } catch (error) {
      return DestinationLocation;
    }
    return DestinationLocation;
  }

  OnSaveAssignVehicle(event) {
    this.IsAssignvehicleSaveDisable = true;
    var obj: any = {};
    obj = event;
    const estimatedDate = new Date(obj.EstimatedDeliveryDate);
    const placementDate = new Date(obj.VehiclePlacementDate);
    if (estimatedDate <= placementDate && estimatedDate != placementDate) {
      this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
      this.IsAssignvehicleSaveDisable = false;
      return;
    }
    // if (obj.EstimatedDeliveryDate <= obj.VehiclePlacementDate && obj.EstimatedDeliveryDate != obj.VehiclePlacementDate) {
    //   this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
    //   this.IsAssignvehicleSaveDisable = false;
    //   return;
    // }
    if (this.ValidateTHCADvanceAmountFlag == true) {
      if (obj.Advance == 0 || obj.Advance == undefined || obj.Advance == null || obj.Advance == "") {
        var message = this.translate.instant("ALERTMESSAGES.AdvanceAmountShoubeGraterThanZero");
        this.toastr.error(message, "Alert");
        this.IsAssignvehicleSaveDisable = false;
        return;
      }
    }

    this.ManualvehicleOrderList = this.CourierList;
    var FinalDestination = this.ManualvehicleOrderList[0].DeliveryLocationCode;
    // this.onClickDataByIdConsignment(obj.ShortName,obj.Transporter,obj.TransporterName,obj.LeadTime,obj.service_code,'')    
    this._appService.GetByTwoId("Booking", "GetOrderAddressFromLocationCode", null, FinalDestination).subscribe(async (response) => {
      var DestinationLocation = "";
      DestinationLocation = response[0].DeliveryAddress;
      var DeliveryAddressUnique: any = [];
      var OrderInfo: any = [];
      var obj1: any = {};
      (obj1.origin = this.ManualvehicleOrderList[0].PickupAddress), (obj1.destination = response[0].DeliveryAddress);
      OrderInfo.push(obj1);

      this.ManualvehicleOrderList.map(function (item) {
        if (ContractedComponent.that.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag == true) {
          item.DeliveryAddress = response[0].DeliveryAddress;
        }
        var existItem = DeliveryAddressUnique.find((x) => x.location == item.DeliveryAddress);
        if (!existItem) {
          var obj: any = {};
          (obj.location = item.DeliveryAddress),
            (obj.stopover = true),
            (obj.Order = 0),
            (obj.RouteOrder = "A");
          DeliveryAddressUnique.push(obj);
        }
      });

      var DeliveryAddressUniqueResult: any = [];
      ContractedComponent.that.calculateRouteOptimization(OrderInfo, DeliveryAddressUnique).then(async (res) => {
        setTimeout(() => {
          DeliveryAddressUniqueResult = res;
          for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
            for (let j = 0; j < DeliveryAddressUniqueResult.length; j++) {
              if (
                this.ManualvehicleOrderList[i].DeliveryAddress ==
                DeliveryAddressUniqueResult[j].location
              ) {
                this.ManualvehicleOrderList[i].RouteOrder =
                  DeliveryAddressUniqueResult[j].RouteOrder;
              }
            }
          }

          for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
            this.ManualvehicleOrderDetail[i] = {};
            this.ManualvehicleOrderDetail[i].OrderID = this.ManualvehicleOrderList[i].Id;
            this.ManualvehicleOrderDetail[i].PickupLocationCode = this.ManualvehicleOrderList[i].PickupLocationCode;
            this.ManualvehicleOrderDetail[i].DeliveryLocationCode = FinalDestination;
            if (this.isSTPBooking) {
              this.ManualvehicleOrderDetail[i].DeliveryLocationCode = this.ManualvehicleOrderList[i].DeliveryLocationCode;
            }
            this.ManualvehicleOrderDetail[i].Qty = this.ManualvehicleOrderList[i].Qty;
            this.ManualvehicleOrderDetail[i].OrderItemsId = this.ManualvehicleOrderList[i].OrderItemsId == undefined ? null : this.ManualvehicleOrderList[i].OrderItemsId;
            this.ManualvehicleOrderDetail[i].VehicleOrdersProductID = this.ManualvehicleOrderList[i].VehicleOrdersProductID == undefined ? null : this.ManualvehicleOrderList[i].VehicleOrdersProductID;
            this.ManualvehicleOrderDetail[i].RouteOrder = this.ManualvehicleOrderList[i].RouteOrder;
          }

          this.ManualvehiclePlanning.ManualvehicleOrderDetail = this.ManualvehicleOrderDetail;
          this.ManualvehiclePlanning.TransportServiceId = obj.TransportService;
          this.ManualvehiclePlanning.TransporterId = obj.Transporter;
          this.ManualvehiclePlanning.VehicleTypeID = obj.VehicleType;
          this.ManualvehiclePlanning.VehicleNo = obj.VehicleNo;
          this.ManualvehiclePlanning.DriverCode = obj.Driver;
          this.ManualvehiclePlanning.DriverMobileNo = obj.DriverMobileNo;
          this.ManualvehiclePlanning.VehiclePlacementDate = obj.VehiclePlacementDate;
          this.ManualvehiclePlanning.EstimatedDeliveryDate = obj.EstimatedDeliveryDate;
          this.ManualvehiclePlanning.BookingType = "primary"; //this.BookingType;
          this.ManualvehiclePlanning.BookingTypeAuto = null;
          this.ManualvehiclePlanning.LeadTime = obj.LeadTime;
          this.ManualvehiclePlanning.Advance = obj.Advance;
          // if (this.isSTPBooking) {
          //   this.ManualvehiclePlanning.BookingTypeAuto = this.STPModelListData[this.STPIdexId].BookingType;
          // }
          this.ManualvehiclePlanning.CompanyId = this.CompanyId;
          this.ManualvehiclePlanning.opa_userId = this.UserId;
          this.ManualvehiclePlanning.Captain = null;
          this.ManualvehiclePlanning.IsFromRouteOptimization = false;
          this.ManualvehiclePlanning.RouteOptimization = true;
          this.ManualvehiclePlanning.PotterTripId = null;
          this.ManualvehiclePlanning.ChargeAmount = 0;
          this.ManualvehiclePlanning.IsFromManualPlanning = false;
          this.ManualvehiclePlanning.ShipNowType = 'Contracted';
          console.log('ContractedComponent.that.ManualvehiclePlanning',ContractedComponent.that.ManualvehiclePlanning);
          console.log('obj for CreateConsignment',obj.ShortName,obj.Transporter,obj.TransporterName,obj.TransporterType,obj.LeadTime);
          
          ContractedComponent.that._appService.Post("ManualvehiclePlanning", "CreateBookingFromManualPlan", ContractedComponent.that.ManualvehiclePlanning).subscribe((response) => {
            this.IsAssignvehicleSaveDisable = false;
            if (response == true) {
              ContractedComponent.that.toastr.success("Booking Created Successfully !", "Success");
              ContractedComponent.that.modalRef.close();
              ContractedComponent.that.router.navigateByUrl(`/FtlList`);
              // if(
              //   obj.TransporterName === 'V-Xpress' ||
              //   obj.TransporterName === 'Delhivery' ||
              //   obj.TransporterName === 'XpressBees' ||
              //   obj.TransporterName === 'OM Logistics' ||
              //   obj.TransporterName === 'Allcargo GATI' ||
              //   obj.TransporterName === 'Smartr Logistics' ||
              //   obj.TransporterName === 'TCI Express' ||
              //   obj.TransporterName === 'Bluedart' ||
              //   obj.TransporterName === 'DTDC' ||
              //   obj.TransporterName === 'Safexpress' ||
              //   obj.TransporterName === 'Relay Express' ||
              //   obj.TransporterName === 'SAFEXPRESS' ||
              //   obj.TransporterName === 'Safexpress' ||
              //   obj.TransporterName === 'Smart Track'
              // ){
              //   this.onClickDataByIdConsignment(obj.ShortName,obj.Transporter,obj.TransporterName,obj.LeadTime,obj.service_code,'')    
              // }else{
              //   ContractedComponent.that.modalRef.close();
              //   ContractedComponent.that.router.navigateByUrl(`/FtlList`);
              // }
            }
          },
            (err) => {
              ContractedComponent.that.toastr.error(err._body.replace(/"/g, ""), "Error");
              this.IsAssignvehicleSaveDisable = false;
            }
          );
        }, 2000);
      });
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        this.IsAssignvehicleSaveDisable = false;
      }
    );
  }

  redirectToFtl() {
    if (this.TransationType == "FTL") {
      this.router.navigateByUrl(`/FtlList`);
    } else {
      this.router.navigateByUrl("/NewBookingList");
    }
  }

  getWalletCount() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this._appService.GetByTwoParam("OrdersByVehicle", "GetWalletCount", this.CompanyId, this.UserId).subscribe(
      (response) => {
        if (response.length > 0) {
          this.Balance = response[0].Balance;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  CreateConsignmentCountry(TransporterId, LeadTime) {
    Helpers.setLoading(true);
    this._appService.GetByEightId("OrdersByVehicle", "oc_ConfirmCourierData_generateInvoiceOrderWiseV2", this.Id, this.UserId, TransporterId, LeadTime, '', '', '', 0).subscribe(
      (response) => {
        if (response[0].isDone == "OK") {
          this.toastr.success("Order Confirm successfully !", "Success");
          Helpers.setLoading(false);
          this.router.navigateByUrl("/NewBookingList");
        } else {
          this.toastr.error(
            "Error Occurred While ConFirm Booking !",
            "Error"
          );
          Helpers.setLoading(false);
        }
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  GetNewShipResultFromAPI() {
    Helpers.setLoading(true);
    this._appService.GetByThreeId("OrdersByVehicle", "GetNewShipResultFromAPI", this.Id, this.CompanyId, this.UserId).subscribe(
      (response) => {
        this.returnData = response;
        if (this.returnData == "1") {
          this.toastr.success("Shipment Addess Successfuylly", "Success");
          Helpers.setLoading(false);
        } else {
          this.toastr.error(this.returnData, "Error");
        }
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }
  // End

  //added by vithu 04-10-2024
  GetTransporterListAir(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    isFilter = false
  ) {
    Helpers.setLoading(true);
    this._appService
      .GetBySevenId(
        "OrdersByVehicle",
        "GetTransportersAir",
        this.CourierList[0].PickupCountry,
        this.CourierList[0].DeliveryCountry,
        this.CourierList[0].TransportService,
        this.CourierList[0].PickupDate,
        this.OrderData.SumOfWeight,
        this.OrderData.SumOfQty,
        this.OrderData.SumOfDimension
      )
      .subscribe(
        (response) => {
          if (response.Table.length) {
            this.totalOrderCount = response.Table.length; //response[0].recordcount;
            this.isListApiCalled = true;
            this.assignTableFields(pageNo, perPage, response.Table);
          }
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(
            this.translate.instant("User.ErrorMessage"),
            "error"
          );
        }
      );
  }

  OnCheckRateClick(event) {
    if (event.isBifurcationVisible == true) {
      Helpers.setLoading(true);
      this._appService.GetByFourId("OrdersByVehicle", "GetCalculateAirRateGST", this.Id, event.ChargeCode, event.UnitRate, event.ServiceType).subscribe(
        (response) => {
          var objList: any = [];
          this.RateBifurcationList = this.RateBifurcationList.filter(obj => obj.selectedIndex !== event.selectedIndex);

          var obj: any = {};
          obj.Label = response.Table[0].ChargeCode;
          obj.Amount = response.Table[0].Rate;
          objList.push(obj);

          obj = {};
          obj.Label = 'Variable Surcharge';
          obj.Amount = response.Table[0].VariableSurcharge;
          objList.push(obj);

          obj = {};
          obj.Label = 'Fixed Surcharge';
          obj.Amount = response.Table[0].FixedSurcharge;
          objList.push(obj);

          obj = {};
          obj.Label = 'IGST';
          obj.Amount = response.Table[0].IGSTAmount;
          objList.push(obj);

          obj = {};
          obj.Label = 'CGST';
          obj.Amount = response.Table[0].CGSTAmount;
          objList.push(obj);

          obj = {};
          obj.Label = 'SGST';
          obj.Amount = response.Table[0].SGSTAmount;
          objList.push(obj);

          var objP: any = {};
          objP.selectedIndex = event.selectedIndex;
          objP.RateBifurcation = objList;

          this.RateBifurcationList.push(objP);

          console.log('ggg', this.RateBifurcationList);
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(
            this.translate.instant("User.ErrorMessage"),
            "error"
          );
        });
    }
  }

  handleOption(event: { category, value,data }) {
      if(event.category.trim() === 'Send Rate Confirmation'){
        if(event.value.trim() === 'Via Mail'){
          this.SendRateConfirmation(event.data, "Mail");
        }
        if (event.value.trim() === 'Via WhatsApp') {
          this.SendRateConfirmation(event.data, "WhatsApp");
        }
      }else if(event.category.trim() === 'Send Vehicle Request'){
        if(event.value.trim() === 'Via Mail'){
          this.SendVehicleRequest(event.data, "Mail");
        }
        if (event.value.trim() === 'Via WhatsApp') {
          this.SendVehicleRequest(event.data, "WhatsApp");
        }
      } else if(event.category.trim() == 'Award Shipment'){ //added by fahim 02-02-2026 :)
        let row = event.data;
        console.log(`${row.CompanyName} Won the aword`);
        this.UpdateAwardShipment(row.trnasporterBidDetailId,row.CompanyName);
      }
  }

  NewButtonHandle(event){
    console.log('NewButtonHandle in ContractedRateBreakup event',event.event);
    console.log('NewButtonHandle in ContractedRateBreakup data',event.data);
    this.ContracTransporterId=event.data.Id;
    this.ContracIndentId=event.data.IndentId;
    this.SelectedVehicleTypeId=event.data.VehicleTypeId;
    this.modalRef = this.modalService.open(this.ContractedRateBreak, {size:"lg",centered: true});
  }

  GetExpenseBifurcation(IndentId,TransporterId,VehicleTypeId) {
    const Payload={
      OrderId:IndentId,
      OwnerId:TransporterId,
      BookingId:null,
      NewVehicleTypeId:VehicleTypeId
    };
   Helpers.setLoading(true)
    this._appService.Post('OrdersByVehicle', 'GetExpenseBifurcationForContracted', Payload).subscribe(
      (response) => {
        if (response && response.length > 0) {

          const chargeBreakup = response.map(x => ({
            ...x,
            OrderId:IndentId,
            TransporterId
          }));

          this.checkShipNowChargeBreakupData(
            IndentId,
            TransporterId,
            VehicleTypeId,
            chargeBreakup
          );
        }
        Helpers.setLoading(false)
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        Helpers.setLoading(false)
      }
    );
  }  

 checkShipNowChargeBreakupData(IndentId, TransporterId,VehicleTypeId, chargeBreakup) {
  const Payload = {
    IndentId,
    TransporterId,
    isBidding: false,
    VehicleTypeId:VehicleTypeId
  };
  
  this._appService
    .Post(
      'OrdersByVehicle',
      'CheackShipNowChargeBreakupData',
    Payload
    )
    .subscribe(
      (response) => {
        if ( 
          response &&
          response.length > 0 &&
          response[0] &&
          response[0].Result === 'No'
        ) {
          this.saveShipNowChargeBreakup(chargeBreakup);
        }
      },
      (error) => {
        console.error('Error while checking charge breakup data');
      }
    );
  }

  saveShipNowChargeBreakup(chargeBreakup) {
  const obj = {
    CreatedBy: this.UserId,
    ShipNowChargeBreakup_Table: chargeBreakup,
    isBidding: false
  };
  this._appService
    .Post('OrdersByVehicle', 'SaveShipNowChargeBreakup', obj)
    .subscribe(
      (response) => {
        console.log('SaveShipNowChargeBreakup Success');
      },
      (error) => {
        console.error('Error while saving SaveShipNowChargeBreakup');
      }
    );
  }

  onRefreshList(event){
    if(event === 'true'){
      this.GetTransporterList();      
    }
  }

  UpdateAwardShipment(Id,Transporter){ //added by fahim 02-02-2026 :)
    this._appService.GetByOneParam('OrdersByVehicle','UpdateAwardShipment',Id).subscribe(
      (response)=>{
        this.toastr.success(`The shipment has been successfully awarded to ${Transporter}`,'Success');
      },
      (error)=>{
        console.error('Error while updating award shipment');
      }
    );
  }

  async onClickDataByIdConsignment(ShortName:any, TransporterId:any, TransporterName:any, LeadTime:any, service_code:any, TotalRate:any) {
      await new Promise(async (resolve1, reject1) => {
        this._appService.GetById("OrdersByVehicle", "oc_GetCourierDataByIdConsignment", this.IndentId).subscribe(
          (response) => {
            var obj: any = {};
            obj.OrderDetails = response.Table[0];
            obj.ProductDetails = response.Table1;
            obj.ProductDimentions = response.Table2;
            obj.InvoiceDetails = response.Table3;
            obj.AdditionalServices = response.Table4;
            obj.OrdersPackage = response.Table5;

            var ConsignmentList: any = [];
            ConsignmentList.push(obj);
            ContractedComponent.that.CreateConsignment(obj,ShortName,this.IndentId,TransporterId,TransporterName,LeadTime,service_code,TotalRate);
            resolve1("OK");
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
            resolve1("OK");
          });
      });
  }
}
